'use client';

import { FC } from 'react';
import { cn } from 'utils/cn';
import MenuExpansive from './MenuExpansive';
import MenuItem from './MenuItem';
import useMenu from './useMenu';

const Menu: FC<unknown> = () => {
  const { menuPartI, menuPartII } = useMenu();

  return (
    <aside className="fixed h-[calc(100vh-80px)] self-stretch" aria-label="Sidebar">
      <div
        className={cn(
          'flex h-full w-60 flex-1 flex-col overflow-y-auto px-3 py-4',
          'bg-white ',
          'justify-between'
        )}
      >
        <ul className="space-y-1">
          {menuPartI.map((menu) => (
            <li key={menu.route + menu.name}>
              {!!menu?.childrens?.length && (
                <MenuExpansive {...menu}>
                  {menu?.childrens?.map((items) => (
                    <MenuItem key={items.name + items.route} {...items} />
                  ))}
                </MenuExpansive>
              )}
              {!menu?.childrens?.length && <MenuItem {...menu} />}
            </li>
          ))}
        </ul>
        <ul className="space-y-1">
          {menuPartII.map((menu) => (
            <li key={menu.route + menu.name}>
              {!!menu?.childrens?.length && (
                <MenuExpansive {...menu}>
                  {menu?.childrens?.map((items) => (
                    <MenuItem key={items.name + items.route} {...items} />
                  ))}
                </MenuExpansive>
              )}
              {!menu?.childrens?.length && <MenuItem {...menu} />}
            </li>
          ))}
        </ul>
      </div>
    </aside>
  );
};

export default Menu;
